import { render, staticRenderFns } from "./AppIcon.vue?vue&type=template&id=fc2c05f4&scoped=true"
import script from "./AppIcon.vue?vue&type=script&lang=ts"
export * from "./AppIcon.vue?vue&type=script&lang=ts"
import style0 from "./AppIcon.vue?vue&type=style&index=0&id=fc2c05f4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2c05f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc2c05f4')) {
      api.createRecord('fc2c05f4', component.options)
    } else {
      api.reload('fc2c05f4', component.options)
    }
    module.hot.accept("./AppIcon.vue?vue&type=template&id=fc2c05f4&scoped=true", function () {
      api.rerender('fc2c05f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/AppIcon.vue"
export default component.exports